import { BigNumber } from '@ethersproject/bignumber';
import { SiloAsset } from 'queries/decoratedSilo';
import { useMemo } from 'react';
import { MaxAmount } from '../../../../hooks/useMaxTokenAmount';
import { BigNumberWithDecimals } from '@silo/types';

type UseIsFullAmountProps = Parameters<DecideIsFullAmount>[0] & {
  decideIsFullAmount?: DecideIsFullAmount;
};

export const useIsFullAmount = ({
  decideIsFullAmount = defaultDecideIsFullAmount,
  normalizedTokenAmount,
  amountInUSD,
  maxAmount,
  maxAmountInUSD,
  selectedAsset,
  priceInUSD,
}: UseIsFullAmountProps): boolean =>
  useMemo(
    () =>
      decideIsFullAmount({
        normalizedTokenAmount,
        amountInUSD,
        maxAmount,
        maxAmountInUSD,
        selectedAsset,
        priceInUSD,
      }),
    [decideIsFullAmount, normalizedTokenAmount, amountInUSD, maxAmount, maxAmountInUSD, selectedAsset, priceInUSD]
  );

export type DecideIsFullAmount = (params: {
  normalizedTokenAmount: BigNumber | null;
  amountInUSD: BigNumberWithDecimals | null;
  maxAmount: MaxAmount;
  maxAmountInUSD: BigNumberWithDecimals | null;
  selectedAsset: SiloAsset;
  priceInUSD: BigNumberWithDecimals | null;
}) => boolean;

const defaultDecideIsFullAmount: DecideIsFullAmount = ({ normalizedTokenAmount, maxAmount }) => {
  if (!normalizedTokenAmount) return false;

  return normalizedTokenAmount.eq(maxAmount.value.bigNumber);
};
